/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import './ManageRoom.css';
import Wrapper from './Wrapper';
import OzModalButton from './partials/OzModalButton';
import RoomForm from './partials/RoomForm';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  getRoom,
  updateRoom,
  listTimeSlots,
  listCompanies,
} from '../actions';


class ManageRoom extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['room', getRoom, p => { return [p.id, {}, { includeDisabled: 1 }] }],
    ['timeSlots', listTimeSlots, p => { return { room: p.id} }],
  ];

  state = {};

  saveChanges(e, values) {
    console.log('save changes to room:', values);
    let room = this.props.room;
    let user = this.props.user;
    this.props.updateRoom(room.id, values)
      .then(resp => {
        console.log('update room resp:', resp);
        if (resp.error) {
          return;
        }

        this.props.listCompanies({ mine: 1 })
          .then(() => {
            setTimeout(() => {
              navTo('/manage');
              NotificationManager.success('Saved changes to ' + room.name);
            }, 1);
          });
      });
  }

  renderRoom() {
    let room = this.props.room;
    if (!room) return;

    let disabledNode;
    if (room.disabled) {
      disabledNode = (
        <div className="disabled"><FontAwesome name="times-circle" /> This room is <b>disabled</b> and will not show on the site ({room.prettyDisabledReason})</div>
      );
    }

    return (
      <div className="room">
        {disabledNode}
        <RoomForm
          errors={this.props.errors.room}
          values={this.props.room}
          onSubmit={(e, values) => this.saveChanges(e, values)}
          buttonText="Save Changes"
        />
      </div>
    )
  }

  render() {
    let room = this.props.room || {};
    return (
      <Wrapper className="ManageRoom" title={'Manage ' + (room.name || '')}>
        <Helmet>
          <title>Manage {room.name || ''}</title>
        </Helmet>
        {this.renderRoom()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    room: state.get.room,
    timeSlots: state.list.timeSlot,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    updateRoom,
    listCompanies,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageRoom);



/** WEBPACK FOOTER **
 ** ./src/components/ManageRoom.js
 **/